import { colors } from 'theme'

export const defaultThemeStyles = {
    background: colors.white,
    previewBorder: colors.greyLight,
    description: colors.darkCloud,
    title: colors.darkBlue,
}
